// 
let addMixin = {
  data() {
    return {
    }
  },
  methods: {
    setTitle(obj) {
      let ua = window.ua;
      if (!ua) {
        ua = this.$route.query.ua || "pc";
        window.ua = ua
      }
      if (ua === "ios") {
        window.webkit.messageHandlers.setTitle.postMessage(obj);
      } else if (ua === "android") {
        emm.setTitle(obj.title);
      } else {
        if(obj.title){
          document.title = obj.title;
        }
      }
    },
  },
  mounted() {},
}
export default addMixin



// WEBPACK FOOTER //
// ./src/mixins/add/add.js